import React from 'react';
import { Button, ButtonProps } from '../Button';

export const BlackAndWhiteButton: React.FC<ButtonProps> = ({
  ...restProps
}) => <Button bw={true} upgrade {...restProps} />;
